import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-information-box',
  templateUrl: './information.box.component.html',
  styleUrls: ['./information.box.component.scss']
})
export class InformationBoxComponent implements OnInit {
@Input() text1: string;
@Input() text1Args: [];
@Input() text2: string;
@Input() text3: string;
@Input() actionTextIndex: number;
@Input() contactPositionIndex: number;
@Input() contactInfo: string;
@Input() icon: string;
@Input() border = true;
@Output() onAction = new EventEmitter();
@HostBinding("class.centered") @Input() centered = false;

  public space = ' ';
  constructor() { }

  ngOnInit() {
  }
}
